module.exports = __webpack_public_path__ + "static/media/main-slider-1_sm.d2cfb8ee.jpg";